<template>
  <div class="container-fluid py-4">
    <div class="row">
      <div class="col-12">
        <div class="card shadow-sm mb-4">
          <div class="card-body">
            <div class="d-flex align-items-center mb-4">
              <AppIcon name="bi-headset" class="bi bi-headset fs-2 me-3" />
              <div>
                <h3 class="mb-1">{{ $t('support') }}</h3>
                <p class="text-muted mb-0">{{ $t('support_description') }}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <!-- Contact Form -->
          <div class="col-lg-8 mb-4">
            <div class="card shadow-sm">
              <div class="card-header bg-white text-dark border-bottom">
                <h5 class="mb-0">
                  <AppIcon name="bi-envelope" class="bi bi-envelope me-2" />{{ $t('contact_us') }}
                </h5>
              </div>
              <div class="card-body">
                <form @submit.prevent="submitContactForm">
                  <div class="row">
                    <div class="col-md-6 mb-3">
                      <label class="form-label">{{ $t('name') }} <span class="text-danger">*</span></label>
                      <input 
                        v-model="form.name" 
                        type="text" 
                        class="form-control" 
                        :placeholder="$t('your_name')"
                        required
                      />
                    </div>
                    <div class="col-md-6 mb-3">
                      <label class="form-label">{{ $t('email') }} <span class="text-danger">*</span></label>
                      <input 
                        v-model="form.email" 
                        type="email" 
                        class="form-control" 
                        :placeholder="$t('your_email')"
                        required
                      />
                    </div>
                  </div>

                  <div class="mb-3">
                    <label class="form-label">{{ $t('subject') }} <span class="text-danger">*</span></label>
                    <input 
                      v-model="form.subject" 
                      type="text" 
                      class="form-control" 
                      :placeholder="$t('subject')"
                      required
                    />
                  </div>

                  <div class="mb-3">
                    <label class="form-label">{{ $t('message') }} <span class="text-danger">*</span></label>
                    <textarea 
                      v-model="form.message" 
                      class="form-control" 
                      rows="6"
                      :placeholder="$t('your_message')"
                      required
                    ></textarea>
                  </div>

                  <div class="d-flex justify-content-end">
                    <button type="submit" class="btn btn-dark" :disabled="submitting">
                      <span v-if="submitting">
                        <span class="spinner-border spinner-border-sm me-2"></span>
                        {{ $t('sending') }}...
                      </span>
                      <span v-else>
                        <AppIcon name="bi-send" class="bi bi-send me-2" />{{ $t('send_message') }}
                      </span>
                    </button>
                  </div>
                </form>

                <div v-if="successMessage" class="alert alert-success mt-3">
                  <AppIcon name="bi-check-circle" class="bi bi-check-circle me-2" />{{ successMessage }}
                </div>
                <div v-if="errorMessage" class="alert alert-danger mt-3">
                  <AppIcon name="bi-exclamation-triangle" class="bi bi-exclamation-triangle me-2" />{{ errorMessage }}
                </div>
              </div>
            </div>
          </div>

          <!-- Contact Information -->
          <div class="col-lg-4 mb-4">
            <div class="card shadow-sm mb-3">
              <div class="card-header bg-white text-dark border-bottom">
                <h5 class="mb-0">
                  <AppIcon name="bi-info-circle" class="bi bi-info-circle me-2" />{{ $t('contact_information') }}
                </h5>
              </div>
              <div class="card-body">
                <div class="mb-3">
                  <div class="d-flex align-items-start mb-2">
                    <AppIcon name="bi-envelope-fill" class="bi bi-envelope-fill me-3 fs-5" />
                    <div>
                      <strong class="d-block">{{ $t('email') }}</strong>
                      <a href="mailto:support@gstocky.com" class="text-decoration-none">
                        support@gstocky.com
                      </a>
                    </div>
                  </div>
                </div>

                <div class="mb-3">
                  <div class="d-flex align-items-start mb-2">
                    <AppIcon name="bi-telephone-fill" class="bi bi-telephone-fill me-3 fs-5" />
                    <div>
                      <strong class="d-block">{{ $t('phone') }}</strong>
                      <a href="tel:+212656477702" class="text-decoration-none">
                        +212 6 56477702
                      </a>
                    </div>
                  </div>
                </div>

                

                <div class="mb-0">
                  <div class="d-flex align-items-start">
                    <AppIcon name="bi-geo-alt-fill" class="bi bi-geo-alt-fill me-3 fs-5" />
                    <div>
                      <strong class="d-block">{{ $t('address') }}</strong>
                      <span>Morocco<br>Marrakech<br></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Live Chat Card -->
            <div class="card shadow-sm">
              <div class="card-header bg-white text-dark border-bottom">
                <h5 class="mb-0">
                  <AppIcon name="bi-chat-dots" class="bi bi-chat-dots me-2" />{{ $t('live_chat') }}
                </h5>
              </div>
              <div class="card-body text-center">
                <AppIcon name="bi-chat-left-dots-fill" class="bi bi-chat-left-dots-fill" style="font-size: 3rem;" />
                <p class="mt-3 mb-3">{{ $t('chat_description') }}</p>
                <button @click="openCrispChat" class="btn btn-dark w-100">
                  <AppIcon name="bi-chat-dots" class="bi bi-chat-dots me-2" />{{ $t('start_chat') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import helper from '../helper';
export default {
  name: 'Support',
  data() {
    return {
      form: {
        name: '',
        email: '',
        subject: '',
        message: ''
      },
      submitting: false,
      successMessage: '',
      errorMessage: ''
    }
  },
  mounted() {
    // Load Crisp chat when component mounts
    this.loadCrispChat();
  },
  beforeDestroy() {
    // Remove Crisp chat when leaving the page
    this.removeCrispChat();
  },
  methods: {
    loadCrispChat() {
      // Check if Crisp is already loaded
      if (window.$crisp) {
        return;
      }

      // Crisp chat configuration
      window.$crisp = [];
      window.CRISP_WEBSITE_ID = "3aa4fac3-42c0-4b5d-9e93-19d7def099d1";

      const script = document.createElement('script');
      script.src = 'https://client.crisp.chat/l.js';
      script.async = true;
      script.id = 'crisp-chat-script';
      document.getElementsByTagName('head')[0].appendChild(script);

      setTimeout(() => {
        window.$crisp.push(['set', 'user:email', this?.user?.email]);

        if(this.$i18n.locale == 'en') {
          window.$crisp.push(["do", "message:show", ["text", "Hello Are you looking for assistance? 👋"]]);
        }else if(this.$i18n.locale == 'ar'){
          window.$crisp.push(["do", "message:show", ["text", "مرحباً هل تبحث عن مساعدة؟ 👋"]]);
        }else if(this.$i18n.locale == 'fr'){
          window.$crisp.push(["do", "message:show", ["text", "Bonjour, avez-vous besoin d'aide ? 👋"]]);
        }else{
          window.$crisp.push(["do", "message:show", ["text", "Hello Are you looking for assistance? 👋"]]);
        }
      }, 2000);
    },
    removeCrispChat() {
      // Remove Crisp chat script
      const crispScript = document.getElementById('crisp-chat-script');
      if (crispScript) {
        crispScript.remove();
      }

      // Remove Crisp chat widget
      const crispWidget = document.getElementById('crisp-chatbox');
      if (crispWidget) {
        crispWidget.remove();
      }

      // Clear Crisp global variables
      if (window.$crisp) {
        delete window.$crisp;
      }
      if (window.CRISP_WEBSITE_ID) {
        delete window.CRISP_WEBSITE_ID;
      }
      if (window.Crisp) {
        delete window.Crisp;
      }
    },
    openCrispChat() {
      // Open Crisp chat if loaded
      if (window.$crisp && window.$crisp.push) {
        window.$crisp.push(['do', 'chat:open']);
      }
    },
    async submitContactForm() {
      this.submitting = true;
      this.successMessage = '';
      this.errorMessage = '';

      try {
        // TODO: Replace with your actual API endpoint
        // const response = await this.$http.post('/api/support/contact', this.form);
        
        // Simulate API call
        await new Promise(resolve => setTimeout(resolve, 1500));
        
        /* window.grecaptcha.ready(() => {
          window.grecaptcha.execute('6LetDZEmAAAAAEr9EdTVoDeg6-saEQYhXVSlrQhO', {action: 'submit'})
              .then( async (token) => {
                if(token){ */

                    try{
                        this.loading = true
                        await helper.customPost(`https://api-v2.gstocky.com/contact-us`,
                        {
                          name : this.form.name,
                          email : this.form.email, 
                          subject : this.form.subject,
                          message : this.form.message,
                          // token : token
                        })

                          // Reset form
                          this.form = {
                            name: '',
                            email: '',
                            subject: '',
                            message: ''
                          };

                        this.loading = false
                        this.successMessage = this.$t('message_sent_success');

                    }catch(error){
                      this.loading = false
                    }
                /* }
              })
              .catch(() => {
                this.loading = false
              })
        }); */
        
      
      } catch (error) {
        this.errorMessage = this.$t('message_sent_error');
        alert('Error submitting contact form: ' + error.message);
      } finally {
        this.submitting = false;
      }
    }
  },
  computed: {
     user(){
        return this.$store.getters.USER 
      },
  }
}
</script>

<style scoped>
.card {
  border: none;
  border-radius: 10px;
}

.card-header {
  border-radius: 10px 10px 0 0 !important;
  padding: 1rem 1.5rem;
}

.form-control {
  border-radius: 8px;
}

.btn {
  border-radius: 8px;
  padding: 0.5rem 1.5rem;
}

a {
  color: #0d6efd;
}

a:hover {
  color: #0a58ca;
}
</style>
